module.exports = __webpack_public_path__ + "img/prof_de.d3b36e46.svg";